import { MapPin, Phone, Mail, Clock, Facebook, Instagram } from "lucide-react";
import logo from "@/assets/logo.png";

const Footer = () => {
  return (
    <footer id="contact" className="bg-foreground text-primary-foreground">
      <div className="container-elegant section-padding">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <img
              src={logo}
              alt="Gracious Gatherings Catering"
              className="w-32 h-32 object-contain mb-4 bg-card rounded-full p-2"
            />
            <p className="text-primary-foreground/70 mb-4">
              Chef-driven catering with Southern hospitality at The Pardue Family
              Foundation Event Center.
            </p>
            <p className="text-accent font-serif italic text-lg">
              "The Chefs Make the Difference"
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-serif text-xl font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-accent mt-1 shrink-0" />
                <span className="text-primary-foreground/80">
                  205 Cox Road
                  <br />
                  Milton, GA 30075
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-accent shrink-0" />
                <a
                  href="tel:+17704410401"
                  className="text-primary-foreground/80 hover:text-accent transition-colors"
                >
                  (770) 441-0401
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-accent shrink-0 mt-1" />
                <a
                  href="mailto:info@graciousgatheringsattheparduecenter.com"
                  className="text-primary-foreground/80 hover:text-accent transition-colors break-all"
                >
                  info@graciousgatheringsattheparduecenter.com
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-serif text-xl font-semibold mb-6">
              Office Hours
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-accent mt-0.5 shrink-0" />
                <div className="text-primary-foreground/80">
                  <p>Monday – Friday</p>
                  <p className="text-sm">9:00 AM – 5:00 PM</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-accent mt-0.5 shrink-0" />
                <div className="text-primary-foreground/80">
                  <p>Saturday</p>
                  <p className="text-sm">By Appointment</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-accent mt-0.5 shrink-0" />
                <div className="text-primary-foreground/80">
                  <p>Sunday</p>
                  <p className="text-sm">By Appointment</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Quick Links & Social */}
          <div>
            <h4 className="font-serif text-xl font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3 mb-8">
              {[
                { href: "#about", label: "About Us" },
                { href: "#venue", label: "The Venue" },
                { href: "#menus", label: "Our Menus" },
                { href: "#booking", label: "Book Now" },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-primary-foreground/80 hover:text-accent transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>

            <h4 className="font-serif text-xl font-semibold mb-4">Follow Us</h4>
            <div className="flex gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-primary-foreground/10 flex items-center justify-center hover:bg-accent hover:text-accent-foreground transition-all"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-primary-foreground/10 flex items-center justify-center hover:bg-accent hover:text-accent-foreground transition-all"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-primary-foreground/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-primary-foreground/60 text-sm text-center md:text-left">
            © {new Date().getFullYear()} Gracious Gatherings Catering. All rights
            reserved.
          </p>
          <p className="text-primary-foreground/60 text-sm">
            Exclusive caterer at The Pardue Family Foundation Event Center
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
